module.exports = {"370203005":"辽宁路街道","370203008":"延安路街道","370203011":"登州路街道","370203013":"宁夏路街道","370203014":"敦化路街道","370203015":"辽源路街道","370203016":"合肥路街道","370203019":"大港街道","370203020":"即墨路街道","370203021":"台东街道","370203022":"镇江路街道","370203025":"浮山新区街道","370203026":"阜新路街道","370203027":"海伦路街道","370203028":"四方街道","370203029":"兴隆路街道","370203030":"水清沟街道","370203031":"洛阳路街道","370203032":"河西街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370203.json
// module id = 1261
// module chunks = 0